<div>
  <div class="btn-list">
    <div class="btn-icon" *ngIf="acao?.can_edit && !acao?.deleted">
      <a [routerLink]="editar()">
        <img src="assets/images/svgs/Editar.svg" alt="Editar">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="info-page">
    <h3>Ação</h3>
  </div>

  <div class="list-info" *ngIf="acao?.description_projeto">
    <h4>Projeto:</h4>
    <p>{{ acao?.description_projeto }}</p>
  </div>

  <div class="list-info" *ngIf="acao?.description_entrega">
    <h4>Entrega:</h4>
    <p>{{ acao?.description_entrega }}</p>
  </div>

  <div class="list-info" *ngIf="acao?.description_indicador">
    <h4>Indicador:</h4>
    <p>{{ acao?.description_indicador }}</p>
  </div>

  <div class="list-info">
    <h4>Ação:</h4>
    <p>{{ acao?.title }}</p>
  </div>

  <div class="list-info">
    <h4>Descrição:</h4>
    <p>{{ acao?.description }}</p>
  </div>

  <div class="list-info">
    <h4>Início:</h4>
    <p>{{ acao?.dt_start }}</p>
  </div>

  <div class="list-info">
    <h4>Término planejado:</h4>
    <p>{{ acao?.deadline }}</p>
  </div>

  <div class="list-info">
    <h4>Responsável:</h4>
    <p>{{ acao?.resp_nome }}</p>
  </div>
  
  <div *ngIf="acao?.deleted" class="list-info alert alert-danger">
    <h4>Excluída</h4>
    <p>Sim</p>
  </div>
</div>

<div class="header_search m-t-lg">
  <div class="title-page">
    <h3>Situação</h3>
  </div>
  <div class="content_search">
    <div class="new-demand" *ngIf="acao?.can_edit_analysis && !acao?.deleted">
      <a class="btn btn-primary" type="btn" [routerLink]="novaSituacao()">Nova Situação</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Status</th>
          <th>Previsão Início</th>
          <th class="text-center">Previsão Conclusão</th>
          <th>Situação</th>
          <th class="text-center">Atualização</th>
          <th>Bloq.</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let situacao of acao?.analysis; let i = index">
          <tr>
            <td class="title status">
              <div>
                <div>{{situacao?.situation}}</div>
                <div [innerHTML]="situacao?.status1"></div>
              </div>
            </td>
            <td class="text-center">{{ situacao?.dt_start }}</td>
            <td class="text-center">{{ situacao?.deadline }}</td>
            <td>
              {{situacao?.description}}
            </td>
            <td class="text-center">
              <div class="m-b-xs">{{situacao?.str_nome}}</div>
              {{situacao?.ctr_dth_atu}}
            </td>
            <td>{{ situacao?.action_lockdown_id ? "Sim" : "Não" }}</td>
            <td class="btn-icon-td">
              <div class="btn-icon btn-icon-text" *ngIf="!situacao?.action_lockdown_id && !acao?.deleted">
                <a class="icon-table m-b-sm" [routerLink]="editarSituacao(situacao?.id)" *ngIf="acao?.can_edit_analysis">
                  <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                </a>
                <span class="icon-table icon-red m-b-sm" (click)="confirmExcluir(situacao?.id)" *ngIf="acao?.can_edit_analysis">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
                <a class="icon-table icon-table-text" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams(situacao?.id)" *ngIf="acao?.can_demand_analysis">
                  Nova demanda
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!acao?.analysis?.length" class="border-b-radius">
          <td class="text-center" colspan="7">Nenhuma Situação Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>